// src/components/ClientsSection.js

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Papa from 'papaparse';
import './ClientsSection.css';

const ClientsSection = () => {
  // --- Animation hooks have been removed ---
  const sectionRef = useRef(null);

  const [featuredClients, setFeaturedClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Make sure this URL is your correct, published CSV link
    const GOOGLE_SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vS-vnnhMphHYIAAYAuQf9bLzsxMTHH58BYB6op3DGwwfk42Bvd2sus8LTqU7J-U1hdbxsEHxmovFOy2/pub?output=csv";

    Papa.parse(GOOGLE_SHEET_URL, {
      download: true,
      header: true,
      complete: (results) => {
        const validData = results.data.filter(row => row.id && row.id.trim() !== "");
        const featured = validData.filter(project =>
          (project.isFeatured && project.isFeatured.toLowerCase().trim() === 'true') &&
          (project.logo && project.logo.trim() !== '')
        );
        setFeaturedClients(featured);
        setIsLoading(false);
      },
      error: (err) => {
        console.error("Error fetching client/project data:", err);
        setError("Could not load client projects.");
        setIsLoading(false);
      },
    });
  }, []);

  // --- SIMPLIFIED EFFECT ---
  // This hook is now ONLY responsible for toggling the 'is-visible' class.
  useEffect(() => {
    const section = sectionRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          section.classList.add('is-visible');
          observer.unobserve(section); // Optional: stop observing once it's visible
        }
      },
      { root: null, threshold: 0.1 }
    );
    if (section) observer.observe(section);
    return () => { if (section) observer.unobserve(section); };
  }, [isLoading]); // Re-run if loading state changes, to ensure observer is attached.

  if (isLoading) {
    return (
      <section className="clients-section">
        <h2 className="clients-title">Our Prominent Clients</h2>
        <p className="clients-subtitle">Loading...</p>
      </section>
    );
  }

  if (error) {
    return (
      <section className="clients-section">
        <h2 className="clients-title">Our Prominent Clients</h2>
        <p className="clients-subtitle" style={{ color: 'red' }}>{error}</p>
      </section>
    );
  }

  return (
    <section className="clients-section" ref={sectionRef}>
      <h2 className="clients-title">Our Prominent Clients</h2>
      <p className="clients-subtitle">
        We are proud to work with leading organizations and visionaries across the industry.
      </p>
      {/* We now pass gridRef directly to the grid container */}
      <div className="clients-grid">
        {featuredClients.map((client) => (
          <div key={client.id} className="client-card">
            <img src={client.logo} alt={`${client.title} logo`} className="client-logo" />
            <div className="client-card-overlay">
              <Link to={`/projects/${client.id}`} className="view-more-btn">
                {client.title}
              </Link>
            </div>
          </div>
        ))}
      </div>
      <Link to="/projects" className="view-all-projects-btn">
        View All Projects
      </Link>
    </section>
  );
};

export default ClientsSection;